export default [
    {
        path: 'relatorio-cuidado-gestacao-puerperio',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-gestacao-puerperio' */
            '@/views/atencao-basica/relatorio-cuidado-gestacao-puerperio/Index'
        ),
        redirect: 'relatorio-cuidado-gestacao-puerperio/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-gestacao-puerperio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-gestacao-puerperio' */
                    '@/views/atencao-basica/relatorio-cuidado-gestacao-puerperio/List.vue'
                ),
            },
        ],
    },
]